// extracted by mini-css-extract-plugin
export default {"_":"Pseudo____yp78Q","letterSpacing":"Pseudo_letterSpacing__j+B5t","l":"Pseudo_l__NtYD1","x":"Pseudo_x__jfPUO","t":"Pseudo_t__wz-4m","highlight":"Pseudo_highlight__oOrA-"};